import React, { useState } from 'react';
import { 
  Table, Card, Button, Space, Typography, Form, Input, Select, Cascader,
  Tag, Alert, Drawer, Radio, Upload, Descriptions, message, Modal
} from 'antd';
import { SearchOutlined, ReloadOutlined, PlusOutlined, EyeOutlined, CloudUploadOutlined, DownloadOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;
const { Option } = Select;

const PRODUCT_ORDER_DATA = [
  { value: 'PROD_Q1', label: '智能摄像机Q1', deviceCount: 1200, children: [
    { value: 'WO-20260401-001', label: '智能摄像机Q1-第一批', deviceCount: 500 },
    { value: 'WO-20260320-005', label: '智能摄像机Q1-第二批', deviceCount: 300 },
    { value: 'WO-20260310-008', label: '智能摄像机Q1-第三批', deviceCount: 400 },
  ]},
  { value: 'PROD_P1', label: '云台机P1', deviceCount: 800, children: [
    { value: 'WO-20260328-002', label: '云台机P1-第一批', deviceCount: 500 },
    { value: 'WO-20260315-006', label: '云台机P1-第二批', deviceCount: 300 },
  ]},
  { value: 'PROD_F1', label: '烟雾报警器F1', deviceCount: 350, children: [
    { value: 'WO-20260325-003', label: '烟雾报警器F1-第一批', deviceCount: 200 },
    { value: 'WO-20260305-009', label: '烟雾报警器F1-第二批', deviceCount: 150 },
  ]},
];
const METHOD_MAP = { '按生产分销': 'blue', '指定设备分销': 'orange' };

const ENT_CASCADE = [
  { value: 'partner', label: '合作企业', children: [
    { value: 'HZ-ZL-001', label: '杭州智联科技有限公司' },
  ]},
  { value: 'child', label: '下级企业', children: [
    { value: 'CD-YS-002', label: '成都云视科技有限公司' },
    { value: 'GZ-YL-002', label: '广州云联物联网有限公司' },
  ]},
];

const MyDistribution = () => {
  const [form] = Form.useForm();
  const [addVisible, setAddVisible] = useState(false);
  const [addForm] = Form.useForm();
  const [detailVisible, setDetailVisible] = useState(false);
  const [currentRecord, setCurrentRecord] = useState(null);
  const [selectMethod, setSelectMethod] = useState('order');
  const [selectedDeviceCount, setSelectedDeviceCount] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedOrder, setSelectedOrder] = useState(null);

  // 所有工单平铺（用于直接选工单时反查产品）
  const allOrders = PRODUCT_ORDER_DATA.flatMap(p => p.children.map(o => ({ ...o, productValue: p.value, productLabel: p.label })));
  // 当前可选工单列表
  const availableOrders = selectedProduct ? (PRODUCT_ORDER_DATA.find(p => p.value === selectedProduct)?.children || []) : allOrders;

  const handleProductChange = (val) => {
    setSelectedProduct(val);
    setSelectedOrder(null);
    setSelectedDeviceCount(null);
  };
  const handleOrderChange = (val) => {
    setSelectedOrder(val);
    if (val) {
      const order = allOrders.find(o => o.value === val);
      if (order) {
        if (!selectedProduct) setSelectedProduct(order.productValue);
        setSelectedDeviceCount(order.deviceCount);
      }
    } else {
      setSelectedDeviceCount(null);
    }
  };

  const dataSource = [
    { key: '1', batchNo: 'DS202604-001', method: '按生产分销', productName: '智能摄像机Q1', productId: 'PROD_Q1', orderName: '智能摄像机Q1-第一批', orderId: 'WO-20260401-001', targetName: '杭州智联科技有限公司', targetId: 'HZ-ZL-001', deviceCount: 500, time: '2026-04-01 10:00:00', updateTime: '2026-04-05 16:30:00',
      devices: [
        { key: 'd1', license: 'LIC_001', productName: '智能摄像机Q1', status: '已激活' },
        { key: 'd2', license: 'LIC_002', productName: '智能摄像机Q1', status: '未激活' },
        { key: 'd3', license: 'LIC_003', productName: '智能摄像机Q1', status: '已激活' },
      ]
    },
    { key: '3', batchNo: 'DS202604-003', method: '指定设备分销', productName: '烟雾报警器F1', productId: 'PROD_F1', targetName: '广州云联物联网有限公司', targetId: 'GZ-YL-002', deviceCount: 100, time: '2026-03-25 09:00:00', updateTime: '2026-03-25 09:00:00', 
      devices: []
    },
  ];

  const columns = [
    { title: '分销批次', dataIndex: 'batchNo', width: 150, render: (t) => <Text copyable style={{ fontFamily: 'monospace', fontSize: 13 }}>{t}</Text> },
    { title: '分销方式', key: 'method', width: 160, render: (_, r) => (<div><Tag color={METHOD_MAP[r.method]}>{r.method}</Tag>{r.method === '按生产分销' && r.orderName && (<div style={{ marginTop: 2 }}><Text style={{ fontSize: 12 }}>{r.orderName}</Text><br/><Text type="secondary" style={{ fontSize: 11 }}>{r.orderId}</Text></div>)}</div>) },
    { title: '产品信息', key: 'product', width: 160, render: (_, r) => (<div><div style={{ fontWeight: 500 }}>{r.productName}</div><Text type="secondary" style={{ fontSize: 12 }}>{r.productId}</Text></div>) },
    { title: '分销下级', key: 'target', width: 200, render: (_, r) => (<div><div style={{ fontWeight: 500 }}>{r.targetName}</div><Text type="secondary" style={{ fontSize: 12 }}>ID: {r.targetId}</Text></div>) },
    { title: '设备数量', dataIndex: 'deviceCount', width: 100, align: 'right', render: (v) => <Text strong>{v} 台</Text> },
    { title: '分销时间', dataIndex: 'time', width: 170, render: (t) => <Text type="secondary">{t}</Text> },
    { title: '操作', key: 'action', width: 80, align: 'center', render: (_, r) => (
      <Button type="link" size="small" icon={<EyeOutlined />} onClick={() => { setCurrentRecord(r); setDetailVisible(true); }}>明细</Button>
    )},
  ];

  return (
    <div style={{ padding: 24 }}>
      <div style={{ marginBottom: 16 }}><Title level={4}>我的设备分销</Title></div>
      <Alert type="info" showIcon style={{ marginBottom: 8, borderRadius: 8 }}
        message={<div>
          <div>将您的设备分配给合作伙伴进行销售，一台设备（License）只能分销给一个分销下级。</div>
        </div>}
      />
      <Card bordered={false} style={{ marginBottom: 8, borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }} bodyStyle={{ padding: '12px 0' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Form form={form} layout="inline" style={{ flex: 1, gap: 0 }}>
            <Form.Item name="distBatch" style={{ marginRight: 8 }}><Input placeholder="分销批次号" allowClear style={{ width: 160 }} /></Form.Item>
            <Form.Item name="license" style={{ marginRight: 8 }}><Input placeholder="License" allowClear style={{ width: 160 }} /></Form.Item>
            <Form.Item style={{ marginRight: 8 }}>
              <Space.Compact>
                <Form.Item name="entType" initialValue="name" noStyle><Select style={{ width: 100 }}><Option value="name">分销下级</Option><Option value="id">企业ID</Option></Select></Form.Item>
                <Form.Item shouldUpdate={(p, c) => p.entType !== c.entType} noStyle>
                  {({ getFieldValue }) => getFieldValue('entType') === 'id' ? (<Form.Item name="ent" noStyle><Input placeholder="企业ID" allowClear style={{ width: 200 }} /></Form.Item>) : (<Form.Item name="ent" noStyle><Cascader placeholder="请选择分销下级" showSearch style={{ width: 200 }} options={ENT_CASCADE} /></Form.Item>)}
                </Form.Item>
              </Space.Compact>
            </Form.Item>
            <Form.Item style={{ marginRight: 8 }}>
              <Space.Compact>
                <Form.Item name="prodType" initialValue="name" noStyle><Select style={{ width: 100 }}><Option value="name">产品名称</Option><Option value="id">产品ID</Option></Select></Form.Item>
                <Form.Item shouldUpdate={(p, c) => p.prodType !== c.prodType} noStyle>
                  {({ getFieldValue }) => getFieldValue('prodType') === 'id' ? (<Form.Item name="prod" noStyle><Input placeholder="产品ID" allowClear style={{ width: 200 }} /></Form.Item>) : (<Form.Item name="prod" noStyle><Select placeholder="请选择产品" allowClear showSearch optionFilterProp="label" style={{ width: 200 }} options={PRODUCT_ORDER_DATA.map(p => ({ value: p.value, label: p.label }))} /></Form.Item>)}
                </Form.Item>
              </Space.Compact>
            </Form.Item>
            <Form.Item style={{ marginRight: 8 }}>
              <Space.Compact>
                <Form.Item name="batchType" initialValue="batch" noStyle><Select style={{ width: 100 }}><Option value="batch">生产批次</Option><Option value="orderId">工单ID</Option></Select></Form.Item>
                <Form.Item shouldUpdate={(p, c) => p.batchType !== c.batchType} noStyle>
                  {({ getFieldValue }) => getFieldValue('batchType') === 'orderId' ? (<Form.Item name="batch" noStyle><Input placeholder="工单ID" allowClear style={{ width: 200 }} /></Form.Item>) : (<Form.Item name="batch" noStyle><Select placeholder="请选择批次" allowClear showSearch optionFilterProp="label" style={{ width: 200 }} options={allOrders.map(o => ({ value: o.value, label: o.label }))} /></Form.Item>)}
                </Form.Item>
              </Space.Compact>
            </Form.Item>
            <Form.Item style={{ marginRight: 0 }}><Space><Button type="primary" icon={<SearchOutlined />}>查询</Button><Button icon={<ReloadOutlined />} onClick={() => form.resetFields()}>重置</Button></Space></Form.Item>
          </Form>
          <Button type="primary" icon={<PlusOutlined />} onClick={() => { addForm.resetFields(); setSelectMethod('order'); setSelectedDeviceCount(null); setSelectedProduct(null); setSelectedOrder(null); setAddVisible(true); }}>发起分销</Button>
        </div>
      </Card>
      <Card bordered={false}>
        <Table columns={columns} dataSource={dataSource} rowKey="key" pagination={{ showSizeChanger: true, showTotal: (t) => `共 ${t} 条记录` }} />
      </Card>

      <Drawer title="发起设备分销" width={640} onClose={() => setAddVisible(false)} open={addVisible} destroyOnClose
        footer={<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 16px' }}>
          {/* TODO: 联调时根据接口校验结果动态展示 */}
          <Space>
            <Button type="link" danger size="small" onClick={() => Modal.error({ title: '非产品下设备', width: 520, okText: '我知道了', content: (<div><div style={{ marginBottom: 8 }}>导入的设备中有 5 台不属于已选产品，请检查后重新上传。</div><div style={{ background: '#fff2f0', padding: '8px 12px', borderRadius: 6, border: '1px solid #ffccc7', fontSize: 12 }}>LIC_101、LIC_102、LIC_103、LIC_104、LIC_105</div></div>) })}>点击查看非产品下设备</Button>
            <Button type="link" danger size="small" onClick={() => Modal.error({ title: '已分销设备', width: 520, okText: '我知道了', content: (<div><div style={{ marginBottom: 8 }}>导入的设备中有 30 台已被分销，无法重复分销。</div><div style={{ background: '#fff2f0', padding: '8px 12px', borderRadius: 6, border: '1px solid #ffccc7', fontSize: 12 }}>LIC_201、LIC_202、LIC_203、LIC_204、LIC_205、LIC_206、LIC_207、LIC_208、LIC_209、LIC_210...</div></div>) })}>已分销设备</Button>
          </Space>
          <Space><Button onClick={() => setAddVisible(false)}>取消</Button><Button type="primary" onClick={() => {
          if (selectMethod === 'device') {
            Modal.error({ title: '分销失败', width: 520, okText: '我知道了', content: (<div><div style={{ marginBottom: 8 }}>存在30台设备已被分配分销，请检查已分配的分销记录，重新配置设备分销。</div><div style={{ background: '#fff2f0', padding: '8px 12px', borderRadius: 6, border: '1px solid #ffccc7', fontSize: 12, display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden', textOverflow: 'ellipsis' }}>LIC_001、LIC_002、LIC_003、LIC_004、LIC_005、LIC_006、LIC_007、LIC_008、LIC_009、LIC_010、LIC_011、LIC_012、LIC_013、LIC_014...</div></div>) });
          } else { message.success('分销已发起'); setAddVisible(false); }
        }}>确认分销</Button></Space></div>}
      >
        <Form form={addForm} layout="vertical">
          <Form.Item label="分销方式">
            <Radio.Group value={selectMethod} onChange={(e) => { setSelectMethod(e.target.value); setSelectedDeviceCount(null); setSelectedProduct(null); setSelectedOrder(null); addForm.resetFields(['licenses']); }}>
              <Radio.Button value="order">按生产批次</Radio.Button>
              <Radio.Button value="device">指定设备</Radio.Button>
            </Radio.Group>
          </Form.Item>
          {selectMethod === 'order' && (<>
            <Form.Item label="选择产品">
              <Select value={selectedProduct} onChange={handleProductChange} placeholder="请选择产品（可选）" allowClear showSearch optionFilterProp="label" style={{ width: '100%' }}
                options={PRODUCT_ORDER_DATA.map(p => ({ value: p.value, label: p.label }))}
              />
              {selectedProduct && <Text type="secondary" style={{ fontSize: 12 }}>产品ID：{selectedProduct}</Text>}
            </Form.Item>
            <Form.Item label="选择生产批次" required>
              <Select value={selectedOrder} onChange={handleOrderChange} placeholder="请选择生产批次" allowClear showSearch optionFilterProp="label" style={{ width: '100%' }}
                options={availableOrders.map(o => { const used = dataSource.some(d => d.orderId === o.value); return { value: o.value, label: `${o.label}（${o.deviceCount}台）${used ? ' - 已配置' : ''}`, disabled: used }; })}
              />
              {selectedOrder && <Text type="secondary" style={{ fontSize: 12 }}>工单ID：{selectedOrder}</Text>}
            </Form.Item>
            {selectedDeviceCount != null && <div style={{ background: '#f6ffed', padding: '8px 16px', borderRadius: 6, border: '1px solid #b7eb8f', marginBottom: 16 }}><Text>该生产批次包含设备：<Text strong style={{ color: '#52c41a', fontSize: 16 }}>{selectedDeviceCount}</Text> 台</Text></div>}
          </>)}
          {selectMethod === 'device' && (<>
            <Form.Item label="选择产品" required>
              <Select value={selectedProduct} onChange={(v) => setSelectedProduct(v)} placeholder="请选择产品" showSearch optionFilterProp="label" style={{ width: '100%' }}
                options={PRODUCT_ORDER_DATA.map(p => ({ value: p.value, label: p.label }))}
              />
              {selectedProduct && <Text type="secondary" style={{ fontSize: 12 }}>产品ID：{selectedProduct}</Text>}
            </Form.Item>
            <Form.Item name="licenses" label="导入分销设备（License）" rules={[{ required: true, message: '请上传' }]} extra="一个License只能分销给一个企业，已分销的将无法再分销。单次最多导入5000个License。">
              <Upload.Dragger maxCount={1} beforeUpload={() => false} style={{ background: '#fff' }}>
                <p className="ant-upload-drag-icon"><CloudUploadOutlined /></p>
                <p className="ant-upload-text">点击或拖拽License文件上传</p>
                <p className="ant-upload-hint">支持 xlsx/xls 格式，单次最多5000条</p>
              </Upload.Dragger>
              <Button type="link" size="small" icon={<DownloadOutlined />} style={{ padding: 0, marginTop: 4 }}>下载导入模板</Button>
            </Form.Item>
          </>)}
          <Form.Item name="targetId" label="分销下级" rules={[{ required: true, message: '请选择' }]}>
            <Cascader placeholder="请选择分销下级" showSearch options={ENT_CASCADE} style={{ width: '100%' }} />
          </Form.Item>
        </Form>
      </Drawer>

      <Drawer title="分销明细" width={700} onClose={() => setDetailVisible(false)} open={detailVisible} destroyOnClose>
        {currentRecord && (<>
          <Descriptions bordered column={1} size="small" style={{ marginBottom: 16 }}>
            <Descriptions.Item label="分销批次">{currentRecord.batchNo}</Descriptions.Item>
            <Descriptions.Item label="分销方式"><Tag color={METHOD_MAP[currentRecord.method]}>{currentRecord.method}</Tag></Descriptions.Item>
            {currentRecord.orderName && <Descriptions.Item label="生产批次">{currentRecord.orderName}（{currentRecord.orderId}）</Descriptions.Item>}
            <Descriptions.Item label="产品信息">{currentRecord.productName}（{currentRecord.productId}）</Descriptions.Item>
            <Descriptions.Item label="分销下级">{currentRecord.targetName}（{currentRecord.targetId}）</Descriptions.Item>
            <Descriptions.Item label="设备数量"><Text strong>{currentRecord.deviceCount} 台</Text></Descriptions.Item>
            <Descriptions.Item label="分销时间">{currentRecord.time}</Descriptions.Item>
          </Descriptions>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
            <Text strong>设备列表</Text>
            <Button size="small" icon={<DownloadOutlined />} onClick={() => message.success('导出成功')}>导出</Button>
          </div>
          <Table size="small" dataSource={currentRecord.devices} rowKey="key"
            pagination={{ showSizeChanger: true, showTotal: (t) => `共 ${t} 台设备` }}
            columns={[
              { title: 'License', dataIndex: 'license', render: (t) => <Text copyable style={{ fontFamily: 'monospace' }}>{t}</Text> },
              { title: '设备状态', dataIndex: 'status', render: (v) => <Tag color={v === '已激活' ? 'green' : 'default'}>{v}</Tag> },
            ]}
          />
        </>)}
      </Drawer>
    </div>
  );
};

export default MyDistribution;
